import { getTruckTotal } from '../trucks/content.js';

export default {
    total: getTruckTotal(),
    updatedDate: '2023年5月16日',
    planDate: '2024年12月'
}